<template>
  <div :class="['main-container', `season-${currentSeason}`]">
    <!-- 背景装饰 -->
    <div class="background-gradient"></div>
    
    
    <!-- 云雾粒子效果 -->
    <div class="cloud-particles">
      <div v-for="i in 10" :key="i" 
           class="cloud-particle"
           :style="{
             width: `${30 + Math.random() * 100}px`,
             height: `${30 + Math.random() * 100}px`,
             left: `${Math.random() * 100}%`,
             top: `${Math.random() * 100}%`,
             opacity: 0.3 + Math.random() * 0.4,
             animation: `float ${5 + Math.random() * 10}s ease-in-out infinite`,
             animationDelay: `${Math.random() * 5}s`
           }"></div>
    </div>



    <!-- 标题展示区域 -->
    <section class="hero-section">
    <!-- 山水背景 -->
      <div class="map-background">
        <div class="map-image"
             style="background-image: url('images/background/HomePageBack.jpg');"></div>
      </div>
      
      <div class="hero-container">
        <div class="hero-content">
          <!-- 左侧文字 -->
          <div class="hero-text">
            <h1 class="hero-title">
              <span v-for="(char, index) in '晋学'" :key="`title-1-${index}`"
                    class="title-char brown"
                    :class="{'animate-title-char': isLoaded}"
                    :style="{animationDelay: `${0.3 + index * 0.2}s`}">
                {{ char }}
              </span>
              <span class="title-space"></span>
              <span v-for="(char, index) in '畅游'" :key="`title-2-${index}`"
                    class="title-char red"
                    :class="{'animate-title-char': isLoaded}"
                    :style="{animationDelay: `${0.7 + index * 0.2}s`}">
                {{ char }}
              </span>
            </h1>
            
            <p class="hero-description"
               :class="{'fade-in': isLoaded}"
               style="transition-delay: 1.3s">
              探索黄土高原的历史文化瑰宝，感受三晋大地的千年文明
            </p>
          </div> 
          
        </div>
      </div>
      
      <!-- 波浪分隔线 -->
      <div class="wave-divider">
        <svg viewBox="0 0 1200 120" preserveAspectRatio="none" class="wave-svg">
          <path d="M0,0V46.29c47.79,22.2,103.59,32.17,158,28,70.36-5.37,136.33-33.31,206.8-37.5C438.64,32.43,512.34,53.67,583,72.05c69.27,18,138.3,24.88,209.4,13.08,36.15-6,69.85-17.84,104.45-29.34C989.49,25,1113-14.29,1200,52.47V0Z" fill="#FFF" opacity=".25"></path>
          <path d="M0,0V15.81C13,36.92,27.64,56.86,47.69,72.05,99.41,111.27,165,111,224.58,91.58c31.15-10.15,60.09-26.07,89.67-39.8,40.92-19,84.73-46,130.83-49.67,36.26-2.85,70.9,9.42,98.6,31.56,31.77,25.39,62.32,62,103.63,73,40.44,10.79,81.35-6.69,119.13-24.28s75.16-39,116.92-43.05c59.73-5.85,113.28,22.88,168.9,38.84,30.2,8.66,59,6.17,87.09-7.5,22.43-10.89,48-26.93,60.65-49.24V0Z" fill="#FFF" opacity=".5"></path>
          <path d="M0,0V5.63C149.93,59,314.09,71.32,475.83,42.57c43-7.64,84.23-20.12,127.61-26.46,59-8.63,112.48,12.24,165.56,35.4C827.93,77.22,886,95.24,951.2,90c86.53-7,172.46-45.71,248.8-84.81V0Z" fill="#FFF"></path>
        </svg>
      </div>
    </section>

    <!-- 热门景点 -->
    <section class="attractions-section">
      <!-- 装饰元素 -->
      <div class="top-divider"></div>
      <div class="section-container">
        <!-- 标题 --> 
        <div class="section-header">
          <h2 class="section-title">
            热门景点
            <span class="title-underline"></span>
          </h2>
          <p class="section-description">
            山西拥有众多世界级文化遗产和自然景观，等待您的探索
          </p>
        </div>
        
        <!-- 3D翻转卡片 -->
        <div class="attractions-grid">
          <div 
            v-for="(attraction) in attractions" 
            :key="attraction.id"
            class="attraction-card-container"
          >
            <div class="attraction-card">
              <!-- 卡片正面 -->
              <div class="card-front">
                <img :src="attraction.image" :alt="attraction.name" class="card-image" />
                <div class="card-overlay"></div>
                <div class="card-content">
                  <h3 class="card-title">{{ attraction.name }}</h3>
                  <div class="card-tags">
                    <span v-for="(tag, tagIndex) in attraction.tags" :key="tagIndex" 
                          class="card-tag">
                      {{ tag }}
                    </span>
                  </div>
                </div>
                
                <!-- 烫金边框 -->
                <div class="card-border"></div>
              </div>
              
              <!-- 卡片背面 -->
              <div class="card-back">
                <h3 class="card-back-title">{{ attraction.name }}</h3>
                <p class="card-description">{{ attraction.description }}</p>
                <div class="card-footer">
                  <span class="card-location">{{ attraction.location }}</span>
                  <button class="navigation-button">
                    <MapPinIcon size="16" />
                    <router-link :to="'scene/' + attraction.routerName" style="color: black; text-decoration: none;">一键导航</router-link>
                  </button>
                </div>
                
                <!-- AR按钮 -->
                <button class="ar-button">
                  <span class="ar-text">AR</span>
                  <span class="ar-tooltip">
                    AR实景预览
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>
        
        <!-- 查看更多按钮 -->
        <div class="view-more">
          <button class="view-more-button" @click="showAttractions">
            查看更多景点
            <ArrowRightIcon size="18" />
          </button>
        </div>
      </div>
    </section>

    <!-- 文化特色 -->
    <section class="culture-section">
      <!-- 装饰元素 -->
      <div class="top-divider"></div>
      <div class="bottom-divider"></div>
      
      <div class="section-container">
        <!-- 标题 -->
        <div class="section-header">
          <h2 class="section-title">
            文化特色
            <span class="title-underline"></span>
          </h2>
          <p class="section-description">
            感受山西独特的历史文化魅力，体验三晋大地的非物质文化遗产
          </p>
        </div>
        
        <!-- 剪纸风格图标 -->
        <div class="culture-grid">
          <div 
            v-for="(feature, index) in culturalFeatures" 
            :key="feature.id"
            class="culture-item"
            @click="jumpToSection(feature.id)"
            :style="{animationDelay: `${index * 0.1}s`}">
        
            <div class="culture-icon-wrapper">
              <!-- 剪纸图标 -->
              <div class="icon-background"></div>
              <div class="icon-container">
                <component :is="feature.icon" size="36" class="feature-icon" />
              </div>
              
              <!-- 装饰边框 -->
              <div class="icon-border"></div>
            </div>
            <!-- <p>{{feature.location}}</p> -->
            <router-link class="feature-title" :to="{path : '/culture' , query : {location : feature.location}}">{{ feature.title }}</router-link>
            <p class="feature-description" >{{ feature.description }}</p>
          </div>
        </div>
      </div>
    </section>

    <!-- 四季体验 -->
    <section class="seasons-section">
      <div class="section-container">
        <!-- 标题 -->
        <div class="section-header">
          <h2 class="section-title">
            四季山西
            <span class="title-underline"></span>
          </h2>
          <p class="section-description">
            每个季节的山西都有不同的风景，带给您不一样的旅行体验
          </p>
        </div>
        
        <!-- 季节切换 -->
        <div class="season-tabs-container">
          <div class="season-tabs">
            <button 
              v-for="(season) in seasons" 
              :key="season.value"
              @click="currentSeason = season.value" 
              class="season-tab"
              :class="{ active: currentSeason === season.value }"
            >
              <!-- 背景色 -->
              <div 
                class="tab-background"
                :class="{ active: currentSeason === season.value }"
                :style="{ backgroundColor: season.color }"
              ></div>
              
              <!-- 季节文字 -->
              <span class="tab-text">
                <component :is="season.icon" size="16" />
                {{ season.label }}
              </span>
            </button>
          </div>
        </div>
        
        <!-- 季节内容 -->
        <div class="season-content">
          <!-- 左侧图片 -->
          <div class="season-image-container">
            <div class="season-main-image">
              <img :src="currentSeasonData.image" :alt="currentSeasonData.title" class="image-cover" />
            </div>
            
            <!-- 装饰元素 -->
            <div class="season-sub-image">
              <img :src="currentSeasonData.subImage" :alt="currentSeasonData.title" class="image-cover" />
            </div>
          </div>
          
          <!-- 右侧内容 -->
          <div class="season-details">
            <h3 class="season-title">
              <component :is="currentSeasonData.icon" size="24" class="season-icon" />
              {{ currentSeasonData.title }}
            </h3>
            
            <p class="season-description">{{ currentSeasonData.description }}</p>
            
            <div class="season-highlights">
              <div v-for="(highlight, index) in currentSeasonData.highlights" :key="index" class="highlight-item">
                <div class="highlight-icon">
                  <CheckIcon size="14" class="check-icon" />
                </div>
                <p class="highlight-text">{{ highlight }}</p>
              </div>
            </div>
            
            <button class="season-button">
              <CalendarIcon size="18" />
              <router-link :to="'/passage/' + currentSeasonData.passage" style="color: black; text-decoration: none;">查看{{ currentSeasonData.title }}行程</router-link>
            </button>
          </div>
        </div>
      </div>
    </section>

    <!-- 底部CTA -->
    <section class="cta-section">
      <!-- 装饰元素 -->
      <div class="cta-background">
        <div v-for="i in 20" :key="`dot-${i}`" 
             class="cta-dot"
             :style="{
               width: `${2 + Math.random() * 4}px`,
               height: `${2 + Math.random() * 4}px`,
               left: `${Math.random() * 100}%`,
               top: `${Math.random() * 100}%`,
               opacity: 0.3 + Math.random() * 0.7
             }"></div>
      </div>
      
      <div class="cta-container">
        <h2 class="cta-title">开启您的山西之旅</h2>
        <p class="cta-description">
          预订您的山西旅行套餐，享受专业导游服务和独家优惠
        </p>
        
        <div class="cta-buttons">
          <button class="cta-primary-button">
            立即预订
          </button>
          <button class="cta-secondary-button">
            联系我们
          </button>
        </div>
      </div>
    </section>
  </div>
</template>

<script setup>
// 引入 useRouter 函数
import { useRouter } from 'vue-router';

// 调用 useRouter 函数创建 router 实例
const router = useRouter();

import { ref, onMounted, computed } from 'vue'
import { 
  MapPin as MapPinIcon,
  ArrowRight as ArrowRightIcon,
  Check as CheckIcon,
  Calendar as CalendarIcon,
  Flower as FlowerIcon,
  Sun as SunIcon,
  Leaf as LeafIcon,
  Snowflake as SnowflakeIcon,
  Landmark as LandmarkIcon,
  Utensils as UtensilsIcon,
  Music as MusicIcon,
  ShoppingBag as ShoppingBagIcon
} from 'lucide-vue-next'

// import { mapGetters } from '../components/commumication/storevuex'

// 页面加载状态
const isLoaded = ref(false)
onMounted(() => {
  setTimeout(() => {
    isLoaded.value = true
  }, 300)
})

// 景点数据
const attractions = [
  {
    id: 1,
    name: "云冈石窟",
    routerName: "yungang",
    image: "/images/yungang.png",
    tags: ["世界遗产", "佛教艺术"],
    description: "云冈石窟位于山西省大同市西郊，始建于北魏文成帝年间，是中国四大石窟之一，以宏伟的气势和精湛的艺术享誉世界。",
    location: "山西省大同市"
  },
  {
    id: 2,
    name: "平遥古城",
    routerName: "pingyao",
    image: "/images/pingyao.png",
    tags: ["世界遗产", "古城"],
    description: "平遥古城是中国保存最为完整的四座古城之一，也是目前我国唯一以整座古城申报世界文化遗产获得成功的古县城。",
    location: "山西省晋中市"
  },
  {
    id: 3,
    name: "五台山",
    routerName: "wutaishan",
    image: "/images/五台山.png",
    tags: ["佛教圣地", "自然风光"],
    description: "五台山是中国四大佛教名山之一，以文殊菩萨道场闻名于世，拥有众多历史悠久的寺庙和壮丽的自然风光。",
    location: "山西省忻州市"
  }
]

// 文化特色
const culturalFeatures = [
  {
    id: 1,
    title: "古建文化",
    location: "gujian",
    description: "山西拥有中国现存数量最多、保存最完好的古建筑群",
    icon: LandmarkIcon
  },
  {
    id: 2,
    title: "晋菜美食",
    location: "meishi",
    description: "以面食为主，讲究色香味形，风味独特的北方菜系",
    icon: UtensilsIcon
  },
  {
    id: 3,
    title: "民间艺术",
    location: "yishu",
    description: "晋剧、剪纸、皮影等多种非物质文化遗产",
    icon: MusicIcon
  },
  {
    id: 4,
    title: "晋商文化",
    location: "jinshang",
    description: "明清时期的商业文明，留下众多商业建筑与文化",
    icon: ShoppingBagIcon
  }
]

// 季节数据
const currentSeason = ref('spring')
const seasons = [
  { value: 'spring', label: '春季', color: '#81C784', icon: FlowerIcon },
  { value: 'summer', label: '夏季', color: '#4FC3F7', icon: SunIcon },
  { value: 'autumn', label: '秋季', color: '#FF8A65', icon: LeafIcon },
  { value: 'winter', label: '冬季', color: '#90A4AE', icon: SnowflakeIcon }
]

// 季节详情数据
const seasonData = {
  spring: {
    title: "春季山西",
    passage :"wutai",
    description: "春季的山西，万物复苏，山花烂漫。这是观赏山西自然风光和古建筑的最佳季节之一，气候宜人，适合徒步和户外活动。",
    image: "images/homeshow/春天景色.png",
    subImage: "images/homeshow/春天景色小.png",
    icon: FlowerIcon,
    highlights: [
      "五台山春季杜鹃花盛开，满山遍野的花海",
      "平遥古城的春日庙会，体验传统民俗活动",
      "晋祠的春季园林景观，古树新花，风景如画"
    ]
  },
  summer: {
    title: "夏季山西",
    passage :"hengshan",
    description: "夏季的山西，绿树成荫，是避暑胜地。高山地区气温凉爽，是逃离城市炎热的理想去处，可以体验不同的自然风光和文化活动。",
    image: "images/homeshow/夏天景色.png",
    subImage: "images/homeshow/夏天景色小.png",
    icon: SunIcon,
    highlights: [
      "恒山的避暑胜地，感受悬空寺的壮观景色",
      "绵山的清凉瀑布，享受大自然的清新",
      "云冈石窟的夏季灯光秀，夜晚的艺术盛宴"
    ]
  },
  autumn: {
    title: "秋季山西",
    passage :"pingyao",
    description: "秋季的山西，层林尽染，是摄影的天堂。金黄的银杏、红色的枫叶，与古建筑相映成趣，创造出独特的视觉体验。",
    image: "images/homeshow/秋天景色.png",
    subImage: "images/homeshow/秋天景色小.png",
    icon: LeafIcon,
    highlights: [
      "平遥古城的秋季，古建筑与金黄落叶的完美结合",
      "王家大院的秋日庭院，感受晋商文化的深厚底蕴",
      "太行山的红叶季，壮观的自然画卷"
    ]
  },
  winter: {
    title: "冬季山西",
    passage :"wutai-winter",
    description: "冬季的山西，银装素裹，别有一番韵味。古建筑在雪中更显古朴，温泉和特色美食让冬季旅行充满温暖。",
    image: "images/homeshow/冬天景色小.png",
    subImage: "images/homeshow/冬天景色.png",
    icon: SnowflakeIcon,
    highlights: [
      "五台山的雪景佛国，圣洁庄严的佛教圣地",
      "平遥古城的冬季灯会，古城墙上的灯火辉煌",
      "晋中温泉，在寒冷冬日享受温暖舒适"
    ]
  }
}

// 当前季节数据
const currentSeasonData = computed(() => {
  return seasonData[currentSeason.value]
})

const showAttractions = () => {
  console.log('查看更多景点')
  // 切换到景点页面
  router.push('/attractions');
}
const jumpToSection = (index) => {
  router.push('/culture').then(() => {
        // 等待页面渲染完成
        const checkElement = () => {
          const section = document.getElementById(`section${index}`);
          if (section) {
            section.scrollIntoView({ behavior: 'smooth' });
          } else {
            // 如果元素未找到，等待一段时间后再次检查
            setTimeout(checkElement, 100);
          }
        };
        checkElement();
      }).catch((error) => {
        console.error('路由导航失败:', error);
      });
    };

  //  mapGetters(['getMessage']),
  //   message(() => {
  //     //return this.getMessage
  //     console.error('出现信息',error)
  //   })
</script>

<style scoped>
/* 基础样式 */
.main-container {
  min-height: 100vh;
  position: relative;
  overflow-x: hidden;
}

/* 背景装饰 */
.background-gradient {
  position: fixed;
  inset: 0;
  z-index: -10;
  background: linear-gradient(to bottom, rgba(245, 222, 179, 0.2), rgba(255, 255, 255, 0.9));
}

.mountain-background {
  position: absolute;
  top: 0;
  bottom: 0;  /* 撑满整个屏幕高度 */
  width: 100%;
}

.mountain-image {
  background-size: cover; /*替换contain保证图片覆盖 */
  background-repeat: no-repeat;
  background-position: center bottom;
  opacity: 0.3; /* 适当提高透明度 */
  filter: grayscale(20%); /* 可选：添加水墨画效果 */
}

.cloud-particles {
  position: fixed;
  inset: 0;
  z-index: -10;
  opacity: 0.2;
}

.cloud-particle {
  position: absolute;
  border-radius: 50%;
  background-color: white;
  filter: blur(16px);
}

/* 导航栏 */
.main-header {
  position: sticky;
  top: 0;
  z-index: 60;
  background-color: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(4px);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.header-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0.75rem 1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.logo-container {
  display: flex;
  align-items: center;
}

.logo-box {
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 0.5rem;
  background-color: #8B4513;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  margin-right: 0.75rem;
}

.logo-text {
  font-family: var(--font-title);
  font-size: 1.25rem;
}

.site-title {
  font-size: 1.25rem;
  font-family: var(--font-title);
  color: #8B4513;
}

.main-nav {
  display: none;
}

@media (min-width: 768px) {
  .main-nav {
    display: flex;
    gap: 1.5rem;
  }
}

.nav-link {
  color: rgba(139, 69, 19, 0.8);
  transition: color 0.3s;
  position: relative;
  padding: 0.5rem 0;
}

.nav-link:hover {
  color: #C3272B;
}

.nav-link-underline {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 0;
  height: 2px;
  background-color: #C3272B;
  transition: width 0.3s;
}

.nav-link:hover .nav-link-underline {
  width: 100%;
}

.season-switcher-container {
  display: none;
}

@media (min-width: 768px) {
  .season-switcher-container {
    display: block;
  }
}

.mobile-menu-button {
  display: block;
  color: #8B4513;
  background: none;
  border: none;
  cursor: pointer;
}

@media (min-width: 768px) {
  .mobile-menu-button {
    display: none;
  }
}

/* 英雄区域 */
.hero-section {
  position: relative;
  min-height: 90vh;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.map-background {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0.33;
}

.map-image {
  width: 96%;
  height: 96%;
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
}

.hero-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 5rem 1rem;
  position: relative;
  z-index: 10;
}

.hero-content {
  display: flex;
  flex-direction: column;
  align-items: center;
}

@media (min-width: 768px) {
  .hero-content {
    flex-direction: row;
  }
}

.hero-text {
  width: 100%;
  text-align: center;
  margin-bottom: 2.5rem;
  margin-left: 150px;
}

@media (min-width: 768px) {
  .hero-text {
    width: 50%;
    text-align: left;
    margin-bottom: 0;
  }
}

.hero-title {
  display: inline-flex;
  flex-direction: column;
}

@media (min-width: 768px) {
  .hero-title {
    flex-direction: row;
  }
}

.title-char {
  font-size: 3rem;
  display: inline-block;
  transform: translateY(20px) scaleY(0);
  opacity: 0;
  transition: all 0.7s;
}

@media (min-width: 768px) {
  .title-char {
    font-size: 4.5rem;
  }
}

.title-char.brown {
  font-family: var(--font-title);
  color: #8B4513;
}

.title-char.red {
  font-family: var(--font-title);
  color: #C3272B;
}

.title-space {
  margin: 0 0.5rem;
}

@media (min-width: 768px) {
  .title-space {
    margin: 0 1rem;
  }
}

.animate-title-char {
  animation: titleChar 0.8s cubic-bezier(0.215, 0.61, 0.355, 1) forwards;
}

.hero-description {
  margin-top: 1.5rem;
  font-size: 1.125rem;
  color: rgba(139, 69, 19, 0.8);
  max-width: 28rem;
  margin-left: auto;
  margin-right: auto;
  opacity: 0;
  transform: translateY(2.5rem);
  transition: all 1s;
}

@media (min-width: 768px) {
  .hero-description {
    margin-left: 0;
    margin-right: 0;
  }
}

.fade-in {
  opacity: 1;
  transform: translateY(0);
}

.hero-buttons {
  margin-top: 2.5rem;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 1rem;
  opacity: 0;
  transform: translateY(2.5rem);
  transition: all 1s;
}

@media (min-width: 768px) {
  .hero-buttons {
    justify-content: flex-start;
  }
}

.primary-button {
  padding: 0.75rem 1.5rem;
  background-color: #C3272B;
  color: white;
  border-radius: 9999px;
  border: none;
  position: relative;
  overflow: hidden;
  cursor: pointer;
  transition: all 0.3s;
}

.primary-button:hover {
  box-shadow: 0 10px 15px -3px rgba(195, 39, 43, 0.2);
}

.button-text {
  position: relative;
  z-index: 10;
}

.button-hover-effect {
  position: absolute;
  inset: 0;
  background-color: #8B4513;
  transform: scaleX(0);
  transform-origin: left;
  transition: transform 0.3s;
}

.primary-button:hover .button-hover-effect {
  transform: scaleX(1);
}

.secondary-button {
  padding: 0.75rem 1.5rem;
  background-color: transparent;
  color: #8B4513;
  border: 2px solid #8B4513;
  border-radius: 9999px;
  cursor: pointer;
  transition: all 0.3s;
}

.secondary-button:hover {
  background-color: rgba(139, 69, 19, 0.1);
}

.hero-image-container {
  width: 100%;
  position: relative;
}

@media (min-width: 768px) {
  .hero-image-container {
    width: 50%;
  }
}

.hero-image-wrapper {
  position: relative;
  width: 100%;
  aspect-ratio: 1/1;
  max-width: 28rem;
  margin: 0 auto;
  opacity: 0;
  transform: translateY(5rem);
  transition: all 1s;
}

.main-image {
  position: absolute;
  inset: 0;
  border-radius: 9999px;
  overflow: hidden;
  border: 8px solid white;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1);
  transform: scale(1);
  transition: transform 0.5s;
}

.main-image:hover {
  transform: scale(1.05);
}

.image-cover {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.decoration-image {
  position: absolute;
  border-radius: 9999px;
  overflow: hidden;
  border: 4px solid white;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
}

.decoration-image-1 {
  top: -2.5rem;
  right: -2.5rem;
  width: 8rem;
  height: 8rem;
  animation: float 6s ease-in-out infinite;
}

.decoration-image-2 {
  bottom: -1.25rem;
  left: -2.5rem;
  width: 7rem;
  height: 7rem;
  animation: float 4s ease-in-out infinite;
}

.chinese-knot {
  position: absolute;
  top: -4rem;
  left: 50%;
  transform: translateX(-50%);
  width: 3rem;
  height: 5rem;
  opacity: 0.8;
}

.wave-divider {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 4rem;
  overflow: hidden;
}

.wave-svg {
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 100%;
}

/* 热门景点 */
.attractions-section {
  padding: 5rem 0;
  background-color: white;
  position: relative;
}

.section-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1rem;
}

.section-header {
  text-align: center;
  margin-bottom: 4rem;
}

.section-title {
  display: inline-block;
  font-size: 1.875rem;
  font-family: var(--font-title);
  color: #8B4513;
  position: relative;
}

@media (min-width: 768px) {
  .section-title {
    font-size: 2.25rem;
  }
}

.title-underline {
  position: absolute;
  bottom: -0.75rem;
  left: 0;
  right: 0;
  height: 0.25rem;
  background-color: #C3272B;
}

.section-description {
  margin-top: 1rem;
  color: rgba(139, 69, 19, 0.7);
  max-width: 36rem;
  margin-left: auto;
  margin-right: auto;
}

.attractions-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 2rem;
}

@media (min-width: 768px) {
  .attractions-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (min-width: 1024px) {
  .attractions-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}

.attraction-card-container {
  perspective: 900px;
}

.attraction-card {
  position: relative;
  height: 20rem;
  transition: transform 0.6s cubic-bezier(0.4, 0, 0.2, 1);
  transform-style: preserve-3d;
  cursor: pointer;
  transform: none;
}

.attraction-card-container:hover .attraction-card {
  transform: rotateY(180deg); 
  transform-style: preserve-3d;
}

/* 添加翻转过渡动画 */
.attraction-card {
  transition: transform 0.6s cubic-bezier(0.4, 0, 0.2, 1);
  transform-origin: center;
}

.card-front, .card-back {
  position: absolute;
  width: 96%;
  height: 100%;
  backface-visibility: hidden;
  border-radius: 0.75rem;
  overflow: hidden;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
}

.card-front {
  background-color: white;
}

.card-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.card-overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.7), transparent);
}

.card-content {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 1.5rem;
  color: white;
}

.card-title {
  font-size: 1.5rem;
  font-family: var(--font-title);
  margin-bottom: 0.5rem;
}

.card-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.card-tag {
  font-size: 0.75rem;
  padding: 0.25rem 0.5rem;
  background-color: rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(4px);
  border-radius: 9999px;
}

.card-border {
  position: absolute;
  inset: 0;
  border: 4px solid rgba(245, 222, 179, 0);
  border-radius: 0.75rem;
  transition: all 0.3s;
  pointer-events: none;
}

.attraction-card-container:hover .card-border {
  border-color: rgba(245, 222, 179, 0.3);
}

.card-back {
  background-color: rgba(245, 222, 179, 0.1);
  transform: rotateY(180deg);
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
}

.card-back-title {
  font-size: 1.25rem;
  font-family: var(--font-title);
  color: #8B4513;
  margin-bottom: 1rem;
}

.card-description {
  color: rgba(139, 69, 19, 0.8);
  flex-grow: 1;
}

.card-footer {
  margin-top: 1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.card-location {
  font-size: 0.875rem;
  color: rgba(139, 69, 19, 0.6);
}

.navigation-button {
  padding: 0.5rem 1rem;
  background-color: #C3272B;
  color: white;
  border: none;
  border-radius: 0.5rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  cursor: pointer;
  transition: background-color 0.3s;
}

.navigation-button:hover {
  background-color: rgba(195, 39, 43, 0.9);
}

.ar-button {
  position: absolute;
  top: 1rem;
  right: 1rem;
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 9999px;
  background-color: #3B5A9D;
  color: white;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s;
}

.ar-button:hover {
  box-shadow: 0 10px 15px -3px rgba(59, 90, 157, 0.2);
}

.ar-text {
  font-size: 0.75rem;
  font-weight: bold;
}

.ar-tooltip {
  position: absolute;
  right: -0.5rem;
  top: 50%;
  transform: translateY(-50%);
  background-color: white;
  color: #3B5A9D;
  font-size: 0.75rem;
  padding: 0.25rem 0.5rem;
  border-radius: 9999px;
  opacity: 0;
  transition: all 0.3s;
  white-space: nowrap;
}

.ar-button:hover .ar-tooltip {
  opacity: 1;
  transform: translateY(-50%) translateX(2rem);
}

.view-more {
  text-align: center;
  margin-top: 6rem;
}

.view-more-button {
  padding: 0.75rem 1.5rem;
  background-color: transparent;
  color: #8B4513;
  border: 2px solid #8B4513;
  border-radius: 9999px;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  cursor: pointer;
  transition: all 0.3s;
}

.view-more-button:hover {
  background-color: #8B4513;
  color: white;
}

/* 文化特色 */
.culture-section {
  padding: 5rem 0;
  background-color: rgba(245, 222, 179, 0.1);
  position: relative;
}

.top-divider, .bottom-divider {
  position: absolute;
  left: 0;
  right: 0;
  height: 1px;
}

.top-divider {
  top: 0;
  background: linear-gradient(to right, transparent, rgba(139, 69, 19, 0.2), transparent);
}

.bottom-divider {
  bottom: 0;
  background: linear-gradient(to right, transparent, rgba(139, 69, 19, 0.2), transparent);
}

.culture-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 2rem;
}

@media (min-width: 768px) {
  .culture-grid {
    grid-template-columns: repeat(4, 1fr);
  }
}

.culture-item {
  text-align: center;
}

.culture-icon-wrapper {
  position: relative;
  width: 6rem;
  height: 6rem;
  margin: 0 auto 1rem;
  transform: scale(1);
  transition: all 0.5s;
}

.culture-item:hover .culture-icon-wrapper {
  transform: scale(1.1);
}

.icon-background {
  position: absolute;
  inset: 0;
  background-color: #C3272B;
  border-radius: 9999px;
  opacity: 0.2;
  transition: opacity 0.3s;
}

.culture-item:hover .icon-background {
  opacity: 0.3;
}

.icon-container {
  position: absolute;
  inset: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.feature-icon {
  color: #C3272B;
}

.icon-border {
  position: absolute;
  inset: 0;
  border: 2px solid rgba(195, 39, 43, 0.5);
  border-radius: 9999px;
  animation: spin-slow 20s linear infinite;
}

.feature-title {
  font-size: 1.25rem;
  font-family: var(--font-title);
  color: #8B4513;
  margin-bottom: 0.5rem;
}

.feature-description {
  font-size: 0.875rem;
  color: rgba(139, 69, 19, 0.7);
}

/* 四季体验 */
.seasons-section {
  padding: 5rem 0;
  background-color: white;
  position: relative;
  overflow: hidden;
}

.season-tabs-container {
  display: flex;
  justify-content: center;
  margin-bottom: 3rem;
}

.season-tabs {
  display: inline-flex;
  background-color: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(4px);
  border-radius: 9999px;
  padding: 0.375rem;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
}

.season-tab {
  position: relative;
  padding: 0.5rem 1.25rem;
  border-radius: 9999px;
  font-size: 0.875rem;
  border: none;
  background: none;
  cursor: pointer;
  transition: all 0.3s;
  color: rgba(139, 69, 19, 0.7);
}

.season-tab:hover {
  color: #8B4513;
}

.season-tab.active {
  color: white;
  font-weight: 500;
}

.tab-background {
  position: absolute;
  inset: 0;
  border-radius: 9999px;
  transition: all 0.3s;
  transform: scale(0);
  opacity: 0;
}

.tab-background.active {
  transform: scale(1);
  opacity: 1;
}

.tab-text {
  position: relative;
  z-index: 10;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.season-content {
  display: grid;
  grid-template-columns: 1fr;
  gap: 3rem;
  align-items: center;
}

@media (min-width: 768px) {
  .season-content {
    grid-template-columns: repeat(2, 1fr);
  }
}

.season-image-container {
  position: relative;
}

.season-main-image {
  position: relative;
  border-radius: 0.75rem;
  overflow: hidden;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1);
  aspect-ratio: 4/3;
}

.season-sub-image {
  position: absolute;
  bottom: -1.5rem;
  right: -1.5rem;
  width: 8rem;
  height: 8rem;
  border: 8px solid white;
  border-radius: 0.75rem;
  overflow: hidden;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
  transform: rotate(6deg);
}

.season-details {
  padding: 1rem;
}

.season-title {
  font-size: 1.5rem;
  font-family: var(--font-title);
  color: #8B4513;
  margin-bottom: 1rem;
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.season-icon {
  color: #C3272B;
}

.season-description {
  color: rgba(139, 69, 19, 0.8);
  margin-bottom: 1.5rem;
}

.season-highlights {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.highlight-item {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
}

.highlight-icon {
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 9999px;
  background-color: #F5DEB3;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin-top: 0.125rem;
}

.check-icon {
  color: #8B4513;
}

.highlight-text {
  color: rgba(139, 69, 19, 0.8);
}

.season-button {
  margin-top: 2rem;
  padding: 0.75rem 1.5rem;
  background-color: #8B4513;
  color: white;
  border: none;
  border-radius: 0.5rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  cursor: pointer;
  transition: background-color 0.3s;
}

.season-button:hover {
  background-color: rgba(139, 69, 19, 0.9);
}

/* 底部CTA */
.cta-section {
  padding: 4rem 0;
  background: linear-gradient(to right, #8B4513, #C3272B);
  color: white;
  position: relative;
  overflow: hidden;
}

.cta-background {
  position: absolute;
  inset: 0;
  overflow: hidden;
  opacity: 0.1;
}

.cta-dot {
  position: absolute;
  border-radius: 50%;
  background-color: white;
}

.cta-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1rem;
  text-align: center;
  position: relative;
  z-index: 10;
}

.cta-title {
  font-size: 1.875rem;
  font-family: var(--font-title);
  margin-bottom: 1.5rem;
}

@media (min-width: 768px) {
  .cta-title {
    font-size: 2.25rem;
  }
}

.cta-description {
  max-width: 36rem;
  margin: 0 auto 2.5rem;
  color: rgba(255, 255, 255, 0.8);
}

.cta-buttons {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 1rem;
}

.cta-primary-button {
  padding: 0.75rem 1.5rem;
  background-color: white;
  color: #8B4513;
  border: none;
  border-radius: 9999px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s;
}

.cta-primary-button:hover {
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.2);
}

.cta-secondary-button {
  padding: 0.75rem 1.5rem;
  background-color: transparent;
  color: white;
  border: 2px solid white;
  border-radius: 9999px;
  cursor: pointer;
  transition: all 0.3s;
}

.cta-secondary-button:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

/* 动画 */
@keyframes titleChar {
  0% {
    opacity: 0;
    transform: translateY(20px) scaleY(0);
  }
  100% {
    opacity: 1;
    transform: translateY(0) scaleY(1);
  }
}

@keyframes float {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-10px); }
}

@keyframes spin-slow {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

/* 季节主题样式 */
.season-spring {
  --season-bg: #E6F4EA;
  --season-accent: #81C784;
}

.season-summer {
  --season-bg: #E1F5FE;
  --season-accent: #4FC3F7;
}

.season-autumn {
  --season-bg: #FFF3E0;
  --season-accent: #FF8A65;
}

.season-winter {
  --season-bg: #F5F5F5;
  --season-accent: #90A4AE;
}
</style>